<template>
  <div class="columns is-multiline">
    <div
      v-for="(dish, index) in dishes"
      :key="index"
      class="column is-one-third"
    >
      <div class="card">
        <div class="card-image">
          <figure class="image is-4by3">
            <img :src="dish.image" :alt="dish.name" />
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{ dish.name }}</p>
              <p class="subtitle is-6">{{ format_currency(dish.price) }}</p>
            </div>
          </div>
          <div class="content">
            {{ truncate(dish.description) }}
          </div>
        </div>
        <footer class="card-footer">
          <div class="buttons">
            <div class="button is-primary" @click="select_dish(dish)">
              <span class="icon">
                <i class="fa fa-check"></i>
              </span>
              <span>{{ $t("select") }}</span>
            </div>
            <div class="button is-info" @click="dish_info(dish)">
              <span class="icon">
                <i class="fa fa-info"></i>
              </span>
              <!-- <span>{{ $t("info") }}</span> -->
            </div>
          </div>
        </footer>
      </div>
    </div>
    <product-modal ref="product_modal" />
  </div>
</template>

<script>
import { warning_message, get, format_currency } from "@/utils";
import { truncate } from "lodash";
import ProductModal from "./product_modal/Index.vue";

export default {
  name: "FoodIndex",
  components: { ProductModal },
  data() {
    return {
      dishes: [
        // {
        //   name: "Ceviche",
        //   price: 15.5,
        //   description: "Plato típico peruano",
        //   image:
        //     "https://www.laylita.com/recetas/wp-content/uploads/1-Ceviche-de-camaron.jpg",
        // },
        // {
        //   name: "Lomo Saltado",
        //   price: 20.5,
        //   description: "Plato típico peruano",
        //   image: "https://i.ytimg.com/vi/r2oGrH__hT0/sddefault.jpg",
        // },
        // {
        //   name: "Arroz con Pollo",
        //   price: 18.5,
        //   description: "Plato típico peruano",
        //   image:
        //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6N2eUlmEPQwYo2IP6wZRD6mPQ2kmzxz5pBw&s",
        // },
      ],
    };
  },
  methods: {
    truncate,
    format_currency,
    select_dish(dish) {
      this.$emit("dish-selected", dish);
    },
    get_dishes() {
      get("/restaurant/product/all", {})
        .then((response) => {
          this.dishes = this.dishes.concat(
            response.map((dish) => {
              return {
                product_id: dish.product_id,
                uuid: dish.uuid,
                name: dish.name,
                price: dish.settings.price,
                description: dish.settings.description,
                image:
                  "https://www.laylita.com/recetas/wp-content/uploads/1-Ceviche-de-camaron.jpg",
              };
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    dish_info(dish) {
      let v = this;
      v.$refs.product_modal.show_modal(dish.uuid);
    },
  },
  mounted() {
    let v = this;
    v.get_dishes();
  },
  created() {},
};
</script>

<style scoped></style>
